import {inject} from 'aurelia-framework';
import { Api } from './services/api';
import { Request, DataService, AuthStatus } from './services/data-service';
import { Router } from 'aurelia-router';

//import 'bootstrap/dist/js/bootstrap.min.js';

@inject(Api, DataService, Router)
export class UserDetail {
	/** Component methods **/
	constructor(api, ds, router){
		this.api 	= api;
		this.ds		= ds;
		this.router	= router;

		this.user	= { username:"you"};
		this.service= { name:"", domain:"", url:"", redirect:"" }
	}

	activate(params){
		this.uid	= params.id;
	}
	attached(){
		// Get user detail info
		if(this.ds.user){
			this.user = this.ds.user;
		}
		else{
			// Verify if token
			let token = this.getCookieByName("l5session");
			if(token){
				let request = new Request("/api/v2/sessions/id/", "GET");
				request.headers["Authorization"] = "Bearer" + token; // Bearer=" + token
				this.api.get(request).then(response => {
					if(response.status === 201){
						// redirect
						this.ds.user = response.data;
						this.ds.auth_status = AuthStatus.Ok;
						this.user = response.data;
					}
				});
			}
		}

		window.setTimeout( () => {
			this.getServices()
				.then(response => { this.handleGetServices(response);});
		}, 600);
	}
	/** Public methods **/
	logout(){
		// Get token from cookie
		let token = this.getCookieByName("l5session");
		// Create request
		let request = new Request("/api/v2/sessions/id/", "DELETE");
		request.headers["Authorization"] = "Bearer " + token; // Bearer + token
		this.api.get(request).then(response => {
			let status = response.status;
			// console.log("res status: ", response);
			if(status === 200){
				// console.log("remove cookie");
				//document.cookie = "l5session= ;domain=localhost;path=/;SameSite=None;Secure";
				document.cookie = "l5session= ;domain=samantia.com;path=/;SameSite=None;Secure";
				// Change status
				this.ds.auth_status = AuthStatus.Unauthenticated;
				this.ds.user		= null;

				// Redirect
				this.router.navigateToRoute('login');
			}
		})
		.catch ((e) => { console.log("err: ", err);});
	}

	/*	MARK: Remote calls
		============================================
	*/

	getServices(){
		let uid 	= this.uid;
		let request = new Request("/api/v2/services/uid?", "GET");
		let params 	= new URLSearchParams({ uid:uid });
		request.url	= request.url + params;

		return this.api.get(request);
	}

	handleGetServices(response){
		this.services = response.data;
	}
	
	postService(myService){
		// Get token from cookie
		let token = this.getCookieByName("l5session");
		// Create request
		let request 	= new Request("/api/v2/services/", "POST");
		request.body 	= { service: myService };
		request.body	= JSON.stringify(request.body);
		request.headers["Authorization"] = "Bearer " + token; // Bearer + token
		return this.api.post(request);		
	}

	handlePostService(response){
		console.log("response => ", response);
	}

	newService(myService){
		this.postService(myService).then(response => {
			this.handlePostService(response);
		});
	}
	
	/*	MARK: Aux functions
		============================================
	*/

	// Get cookies 
	getCookieByName(name){
		const match = document.cookie
			  .match(new RegExp("(^| )" + name + "=([^;]+)"));

		if (match) return match[2];
		return null;
		
	}// end cookie
}
